/* Native inline accordions inside the existing mobile filter drawer. */
(() => {
  const railObservers = new WeakMap();
  function prepareNavigation(navigation) {
    const grid = navigation.querySelector('[data-ccn-grid]');
    const nav = grid?.parentElement;
    if (!grid || !nav) return;
    if (railObservers.has(grid)) { railObservers.get(grid).update(); return; }
    nav.classList.add('local-category-rail');
    const buttons = [-1, 1].map(direction => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'local-category-step';
      button.setAttribute('aria-label', direction < 0 ? 'Catégories précédentes' : 'Catégories suivantes');
      button.innerHTML = `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${direction < 0 ? 'm14 6-6 6 6 6' : 'm10 6 6 6-6 6'}"/></svg>`;
      button.hidden = true;
      button.addEventListener('click', () => grid.scrollBy({
        left: direction * Math.max(160, grid.clientWidth * .75),
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      }));
      return button;
    });
    nav.prepend(buttons[0]);
    nav.append(buttons[1]);
    const update = () => {
      // Measure the full rail, including arrow space, to avoid resize oscillation.
      const overflow = grid.scrollWidth > nav.clientWidth + 1;
      buttons.forEach(button => { button.hidden = !overflow; });
      buttons[0].disabled = grid.scrollLeft <= 1;
      buttons[1].disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2;
    };
    const resize = new ResizeObserver(update);
    resize.observe(nav);
    resize.observe(grid);
    grid.addEventListener('scroll', update, { passive: true });
    railObservers.set(grid, { update, resize });
    update();
  }
  function toggleDrawer(open) {
    const drawer = document.querySelector('.mobile-facets__disclosure');
    const trigger = drawer?.querySelector('.mobile-facets__open-wrapper');
    if (!drawer || !trigger) return;
    drawer.open = open;
    drawer.classList.toggle('menu-opening', open);
    trigger.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('overflow-hidden-mobile', open);
    if (open) {
      document.documentElement.style.setProperty('--viewport-height', `${innerHeight}px`);
      window.trapFocus?.(drawer, drawer.querySelector('.mobile-facets__close'));
    } else window.removeTrapFocus?.(trigger);
  }
  function prepare() {
    // Mobile sort reuses the original Shopify form and its AJAX filtering path.
    const nativeSort = document.querySelector('#FacetFiltersFormMobile select[name="sort_by"]');
    const facets = nativeSort?.closest('.facets-container');
    if (facets) {
      let control = facets.querySelector('.nr-mobile-sort');
      if (!control) {
        control = document.createElement('label');
        control.className = 'nr-mobile-sort';
        const label = document.createElement('span');
        label.textContent = 'Trier par';
        label.setAttribute('aria-hidden', 'true');
        const select = document.createElement('select');
        select.setAttribute('aria-label', 'Trier par');
        control.append(label, select);
        facets.append(control);
      }
      const select = control.querySelector('select');
      if (!select.dataset.nrSortBound) {
        select.dataset.nrSortBound = 'true';
        select.addEventListener('change', () => {
          const original = document.querySelector('#FacetFiltersFormMobile select[name="sort_by"]');
          if (!original) return;
          original.value = select.value;
          original.dispatchEvent(new Event('input', { bubbles: true }));
          original.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      const signature = [...nativeSort.options].map(o => `${o.value}:${o.textContent.trim()}`).join('|');
      if (select.dataset.options !== signature) {
        select.replaceChildren(...[...nativeSort.options].map(o => new Option(o.textContent.trim(), o.value)));
        select.dataset.options = signature;
      }
      select.value = nativeSort.value;
    }
    const heading = document.querySelector('.cabane-catalog-heading');
    const navigation = document.querySelector('cabane-category-navigation');
    if (heading) {
      heading.classList.add('local-catalog-heading');
      if (navigation && navigation.dataset.hub !== 'true') {
        if (navigation.parentElement !== heading) heading.append(navigation);
        prepareNavigation(navigation);
        const grid = navigation.querySelector('[data-ccn-grid]');
        railObservers.get(grid)?.update();
      }
    }
    document.querySelectorAll('.cabane-filter-toggle__closed, .cabane-filter-toggle__open').forEach(label => {
      const text = label.classList.contains('cabane-filter-toggle__open') ? 'Masquer les filtres' : 'Afficher les filtres';
      if (label.textContent !== text) label.textContent = text;
    });
    document.querySelectorAll('#FacetSortForm .cabane-sort-select__trigger').forEach(trigger => {
      if (trigger.querySelector('.local-sort-prefix')) return;
      const prefix = document.createElement('span');
      prefix.className = 'local-sort-prefix';
      prefix.setAttribute('aria-hidden', 'true');
      prefix.textContent = 'Trier par :';
      trigger.prepend(prefix);
    });
    document.querySelectorAll('#FacetSortForm .sorting .select:not(.cabane-sort-select)').forEach(wrapper => {
      const select = wrapper.querySelector('select[name="sort_by"]');
      if (!select) return;
      if (!wrapper.classList.contains('local-native-sort')) {
        wrapper.classList.add('local-native-sort');
        const prefix = document.createElement('span');
        prefix.className = 'local-sort-prefix';
        prefix.setAttribute('aria-hidden', 'true');
        prefix.textContent = 'Trier par :';
        wrapper.prepend(prefix);
        select.addEventListener('change', () => {
          wrapper.style.setProperty('--local-sort-chars', select.selectedOptions[0]?.textContent.trim().length || 10);
        });
      }
      wrapper.style.setProperty('--local-sort-chars', select.selectedOptions[0]?.textContent.trim().length || 10);
    });
    // Use the real Shopify price inputs, preserving their validation and events.
    document.querySelectorAll('price-range').forEach(range => {
      if (range.querySelector('.local-price-inputs')) return;
      const inputs = [...range.querySelectorAll('.cabane-price-fields input[type="number"]')];
      if (inputs.length !== 2) return;
      const fields = document.createElement('div');
      fields.className = 'local-price-inputs';
      inputs.forEach((input, index) => {
        const label = document.createElement('label');
        label.className = 'local-price-field';
        const title = document.createElement('span');
        title.className = 'local-price-title';
        title.textContent = index === 0 ? 'Min.' : 'Max.';
        const row = document.createElement('span');
        row.className = 'local-price-value';
        const currency = document.createElement('span');
        currency.textContent = '€';
        currency.setAttribute('aria-hidden', 'true');
        input.className = 'local-price-input';
        input.setAttribute('aria-label', index === 0 ? 'Prix minimum en euros' : 'Prix maximum en euros');
        row.append(input, currency);
        label.append(title, row);
        fields.append(label);
      });
      range.prepend(fields);
      range.querySelector('.cabane-price-fields')?.remove();
      range.querySelector('.cabane-price-slider__values')?.style.setProperty('display', 'none', 'important');
    });
    // Keep every original facet/value and only simplify its visible label.
    document.querySelectorAll('#FacetFiltersForm .facet-checkbox__text, #FacetFiltersFormMobile .facet-checkbox__text').forEach(label => {
      const text = label.textContent.replace(/\s*\(\d+\)\s*$/, '').trim();
      if (label.textContent !== text) label.textContent = text;
    });
    const trigger = document.querySelector('.mobile-facets__open-wrapper');
    trigger?.setAttribute('role', 'button');
    document.querySelectorAll('#FacetFiltersFormMobile .mobile-facets__details').forEach(details => {
      if (!details.dataset.localFilter) {
        details.dataset.localFilter = 'true';
        details.open = true;
        details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
      }
      // Saved mobile snapshots omit values; use their matching desktop input.
      details.querySelectorAll('input[type="checkbox"]:not([value])').forEach(input => {
        const desktop = document.getElementById(input.id.replace('-mobile-', '-'));
        if (desktop) input.value = desktop.value;
      });
    });
  }
  window.addEventListener('click', event => {
    if (event.target.closest('.mobile-facets__close, #FacetFiltersFormMobile .mobile-facets__footer > button')) {
      event.preventDefault(); event.stopImmediatePropagation(); toggleDrawer(false); return;
    }
    const trigger = event.target.closest('.mobile-facets__open-wrapper');
    if (trigger) {
      event.preventDefault(); event.stopImmediatePropagation(); toggleDrawer(!trigger.parentElement.open); return;
    }
    const summary = event.target.closest('#FacetFiltersFormMobile .mobile-facets__details > summary');
    if (!summary) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const details = summary.parentElement;
    details.open = !details.open;
    summary.setAttribute('aria-expanded', String(details.open));
  }, true);
  document.addEventListener('keydown', event => {
    if (['Enter', ' '].includes(event.key) && event.target.closest('.mobile-facets__close')) {
      event.preventDefault(); event.stopImmediatePropagation(); toggleDrawer(false); return;
    }
    if (event.key === 'Escape' && document.querySelector('.mobile-facets__disclosure[open]')) {
      event.preventDefault(); event.stopImmediatePropagation(); toggleDrawer(false);
    }
  }, true);
  // Titles, counts and category links can arrive after the initial page load,
  // and filtering replaces sections outside the original facets wrapper.
  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; prepare(); });
  };
  prepare();
  const root = document.querySelector('#MainContent');
  if (root && /\/(collections|search)(\/|$)/.test(location.pathname)) {
    new MutationObserver(schedule).observe(root, {childList: true, subtree: true});
  }
  document.addEventListener('shopify:section:load', schedule);
})();
